// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1jA11","title":"ClientInsurance_title__37zsr","itemText":"ClientInsurance_itemText__3Of44"};